import { format } from "date-fns";
import { EmailListItem } from "../utils/Types.ts";
import { Paperclip } from "lucide-react";
import ListItemPlaceholder from "./ListItemPlaceholder.tsx";
import { ContactLabel } from "./ContactLabel.tsx";
import { Card } from "@/components/ui/card";
import { useState } from "react";

interface EmailListProps {
  emails: EmailListItem[] | null;
  loading: boolean;
  onSelectionChange: (selectedEmail: EmailListItem | null) => void;
  selection: string | undefined;
}

const EmailList: React.FC<EmailListProps> = ({ onSelectionChange, selection, emails, loading }) => {
  const [_, setSelectedIndex] = useState<number>(0);
  const handleClick = (i: number) => {
    setSelectedIndex(i);
    if (emails) {
      const newValue: EmailListItem = emails[i];
      if (onSelectionChange) {
        if (selection) {
          if (newValue.id !== selection) onSelectionChange(newValue);
        } else onSelectionChange(newValue);
      }
    }
  };

  let body = null;
  if (loading) {
    body = (
      <div>
        <ListItemPlaceholder />
        <ListItemPlaceholder />
      </div>
    );
  } else {
    body = (
      <div className="flex flex-col gap-y-1 w-[480px]">
        {emails &&
          emails.map((email: EmailListItem, i: number) => (
            <Card
              className={`pt-4 pb-1 px-4 text-muted-foreground rounded-md shadow-none cursor-pointer hover:border-accent-foreground ${
                selection && email.id === selection ? "text-card-foreground border-2 border-ring" : "border-none"
              }`}
              key={i}
              onClick={() => {
                handleClick(i);
              }}
            >
              <div className="text-sm font-normal">
                <ContactLabel
                  displayName={email.from.name || email.from.address}
                  identity={email.from.address.toLowerCase()}
                />
              </div>
              <div className="text-base ">{email.subject}</div>
              <div className="flex py-3 text-xs">
                <span>{format(email.sent.toLocaleString(), "MM-dd-yyyy h:mm aaa")}</span>
                <span className="grow relative">
                  {email.attachments > 0 && <Paperclip className="w-4 h-4 text-muted-foreground absolute right-0" />}
                </span>
              </div>
            </Card>
          ))}
      </div>
    );
  }

  return <div className="flex flex-col space-y-4 w-full pt-8 max-w-[540px]">{body}</div>;
};

export default EmailList;
